import { render, staticRenderFns } from "./blog4.vue?vue&type=template&id=2642ae65"
import script from "./blog4.vue?vue&type=script&lang=js"
export * from "./blog4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports